/**
 * Moon Energy — Collection / Shop Page JS
 * Client-side category filtering and sorting
 * Filtering matches against product title (always contains garment name)
 */
(function () {
  'use strict';

  const filterBtns = document.querySelectorAll('.filter-btn');
  const sortSelect = document.getElementById('sort-select');
  const productCards = document.querySelectorAll('.shop-product-card');

  if (!productCards.length) return;

  let activeCategory = 'All';
  let sortBy = 'featured';

  /* Map filter button categories to keywords found in product titles */
  const CATEGORY_KEYWORDS = {
    'hoodies':       ['hoodie'],
    'sweatpants':    ['sweatpant', 'sweat pant', 'jogger'],
    't-shirts':      ['t-shirt', 'tshirt', 'tee'],
    'shorts':        ['short'],
    'crops & tanks': ['crop', 'tank'],
    'yoga & sports': ['yoga', 'sport'],
    'dresses':       ['dress'],
  };

  function titleMatchesCategory(titleLower, category) {
    const keywords = CATEGORY_KEYWORDS[category.toLowerCase()];
    if (!keywords) return false;
    return keywords.some(kw => titleLower.includes(kw));
  }

  function applyFiltersAndSort() {
    let visible = Array.from(productCards).filter(card => {
      if (activeCategory === 'All') return true;
      const titleLower = (card.dataset.titleLower || '').toLowerCase();
      if (!titleLower) return false;
      return titleMatchesCategory(titleLower, activeCategory);
    });

    productCards.forEach(c => c.style.display = 'none');

    if (sortBy === 'price-low') {
      visible.sort((a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price));
    } else if (sortBy === 'price-high') {
      visible.sort((a, b) => parseFloat(b.dataset.price) - parseFloat(a.dataset.price));
    } else if (sortBy === 'name') {
      visible.sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || ''));
    }

    const grid = document.getElementById('shop-grid');
    visible.forEach(c => {
      c.style.display = '';
      if (grid) grid.appendChild(c);
    });

    const noResults = document.getElementById('no-products-filter');
    if (noResults) noResults.style.display = visible.length === 0 ? 'block' : 'none';
  }

  filterBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      filterBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      activeCategory = this.dataset.category;
      applyFiltersAndSort();
    });
  });

  /* ---- Mobile category native select ---- */
  var mobileCatSelect = document.getElementById('mobile-cat-select');
  if (mobileCatSelect) {
    mobileCatSelect.addEventListener('change', function () {
      var cat = this.value;
      activeCategory = cat;
      // Sync desktop filter buttons
      filterBtns.forEach(function (b) { b.classList.remove('active'); });
      var matchingBtn = document.querySelector('.filter-btn[data-category="' + cat + '"]');
      if (matchingBtn) matchingBtn.classList.add('active');
      applyFiltersAndSort();
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      sortBy = this.value;
      applyFiltersAndSort();
    });
  }

  /* ---- Add to Cart: size → color → add ---- */
  var currentCard = null;
  var currentVariants = [];
  var selectedSize = null;
  var sizeIdx = -1;
  var colorIdx = -1;

  function getOptVal(variant, idx) {
    if (idx === 0) return variant.option1;
    if (idx === 1) return variant.option2;
    if (idx === 2) return variant.option3;
    return null;
  }

  function closeAllPopups() {
    document.querySelectorAll('.shop-product-card .size-popup').forEach(function (p) {
      p.style.display = 'none';
    });
    currentCard = null;
    selectedSize = null;
  }

  function showColorPopup(card, variants, size) {
    var colorPopup = card.querySelector('.color-popup');
    var colorOptions = card.querySelector('.color-options');
    if (!colorPopup || !colorOptions) return;

    var eligible = variants.filter(function (v) {
      if (!v.available) return false;
      if (size !== null && sizeIdx !== -1) return getOptVal(v, sizeIdx) === size;
      return true;
    });

    // No available variants for this selection — fall back to product page
    if (!eligible.length) { fallbackToProductPage(card); return; }

    // Single eligible variant — add directly, no color step
    if (eligible.length === 1) {
      if (window.addToCart) window.addToCart(eligible[0].id, 1);
      closeAllPopups();
      return;
    }

    // No recognized color option — only safe to add if exactly one eligible variant remains;
    // otherwise the selection is ambiguous so redirect to the product page.
    if (colorIdx === -1) {
      if (eligible.length === 1) {
        if (window.addToCart) window.addToCart(eligible[0].id, 1);
      } else {
        fallbackToProductPage(card);
      }
      closeAllPopups();
      return;
    }

    var colors = [];
    eligible.forEach(function (v) {
      var c = getOptVal(v, colorIdx);
      if (c && colors.indexOf(c) === -1) colors.push(c);
    });

    // Color option exists but no values resolved — fall back to product page
    if (!colors.length) { fallbackToProductPage(card); return; }

    colorOptions.innerHTML = '';
    colors.forEach(function (color) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'color-option';
      btn.textContent = color;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Use filter (not find) so we detect ambiguity from a third option.
        // Only add to cart when exactly one variant matches; otherwise the
        // selection is still under-specified and we redirect to the product page.
        var matches = eligible.filter(function (v) { return getOptVal(v, colorIdx) === color; });
        if (matches.length === 1 && window.addToCart) {
          window.addToCart(matches[0].id, 1);
          closeAllPopups();
        } else {
          closeAllPopups();
          fallbackToProductPage(card);
        }
      });
      colorOptions.appendChild(btn);
    });

    colorPopup.style.display = '';
    currentCard = card;
  }

  function fallbackToProductPage(card) {
    var btn = card.querySelector('.add-to-cart-btn');
    var url = (btn && btn.dataset.productUrl) || (card.querySelector('a') && card.querySelector('a').href) || '#';
    window.location.href = url;
  }

  function showSizePopup(card, variants, options) {
    sizeIdx = options.findIndex(function (o) { return o.toLowerCase() === 'size'; });
    colorIdx = options.findIndex(function (o) { return o.toLowerCase() === 'color'; });

    // Single variant — add only if available; otherwise fall back to product page
    if (variants.length === 1) {
      if (variants[0].available) {
        if (window.addToCart) window.addToCart(variants[0].id, 1);
      } else {
        fallbackToProductPage(card);
      }
      return;
    }

    // No size option — skip straight to color step
    if (sizeIdx === -1) {
      showColorPopup(card, variants, null);
      return;
    }

    var sizePopup = card.querySelector('.size-popup:not(.color-popup)');
    var sizeOptions = card.querySelector('.size-options');
    var colorPopup = card.querySelector('.color-popup');
    if (!sizePopup || !sizeOptions) return;

    if (colorPopup) colorPopup.style.display = 'none';

    var sizes = [];
    variants.forEach(function (v) {
      if (!v.available) return;
      var s = getOptVal(v, sizeIdx);
      if (s && sizes.indexOf(s) === -1) sizes.push(s);
    });

    // All variants sold out — fall back to product page
    if (!sizes.length) { fallbackToProductPage(card); return; }

    sizeOptions.innerHTML = '';
    sizes.forEach(function (size) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'size-option';
      btn.textContent = size;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        selectedSize = size;
        sizePopup.style.display = 'none';
        showColorPopup(card, variants, size);
      });
      sizeOptions.appendChild(btn);
    });

    sizePopup.style.display = '';
    currentCard = card;
  }

  document.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var card = btn.closest('.shop-product-card');
      if (!card) return;

      // Toggle: clicking same card's button again closes the popup
      if (currentCard === card) { closeAllPopups(); return; }

      closeAllPopups();

      var variants = [];
      var options = [];
      try {
        variants = JSON.parse(card.dataset.variants || '[]');
        options  = JSON.parse(card.dataset.options  || '[]');
      } catch (err) {
        window.location.href = btn.dataset.productUrl || '#';
        return;
      }

      if (!variants.length) {
        window.location.href = btn.dataset.productUrl || '#';
        return;
      }

      showSizePopup(card, variants, options);
    });
  });

  // Close on outside click
  document.addEventListener('mousedown', function (e) {
    if (currentCard && !currentCard.contains(e.target)) closeAllPopups();
  });
  document.addEventListener('touchstart', function (e) {
    if (currentCard && !currentCard.contains(e.target)) closeAllPopups();
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPopups();
  });

  /* ---- Per-card image carousel (hover arrows) ---- */
  document.querySelectorAll('.shop-product-image').forEach(function (imgWrap) {
    var raw = imgWrap.getAttribute('data-images');
    if (!raw) return;
    var images;
    try {
      images = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!images || images.length < 2) return;

    var imgEl = imgWrap.querySelector('.card-carousel-img');
    var prevBtn = imgWrap.querySelector('.card-carousel-prev');
    var nextBtn = imgWrap.querySelector('.card-carousel-next');
    var index = 0;

    function show(i) {
      index = ((i % images.length) + images.length) % images.length;
      var image = images[index];
      if (imgEl && image) {
        imgEl.src = image.src600 || image.src;
        imgEl.srcset = (image.src600 || image.src) + ' 600w, ' + image.src + ' 1200w';
        imgEl.alt = image.alt || '';
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(index + 1);
      });
    }
  });

})();
